<template>
    <div>
        <div class="columns toolbar-box">
            <div class="column is-2">
                <h1 class="title is-3 between-center">
                    <span>
                        <span>Audit Logs</span>
                        <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                            <o-icon pack="fa" icon="gear" size="is-small"/>
                        </a>
                    </span>
                </h1>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <autocomplete-select type="user" v-model="filters.user_id" @input="fetchPaginatedData(true)" />
                </o-field>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <o-select placeholder="Reference" v-model="filters.reference_type" :expanded="true" @input="fetchPaginatedData(true)">
                        <option :value="null">Not Specified</option>
                        <option
                            v-for="type in referenceTypes"
                            :value="type.id"
                            :key="type.id"
                        >
                            {{ type.name }}
                        </option>
                    </o-select>
                </o-field>
            </div>
            <div class="column is-6">
                <div class="field is-grouped is-grouped-right">
                    <p v-if="isResetFiltersButtonVisible" class="control">
                        <a @click.prevent="resetFilters" class="button is-info"><span>Reset filters</span></a>
                    </p>
                    <p v-if="isDeleteSelectedButtonVisible" class="control">
                        <a @click.prevent="confirmCustomDelete" class="button is-danger"><span>Delete selected</span></a>
                    </p>
                </div>
            </div>
        </div>
        <o-table
            class="is-responsive is-responsive-xs-desktop"

            v-if="isTableVisible"
            :data="paginatedData"

            :bordered="table.bordered"
            :striped="table.striped"
            :narrowed="table.narrowed"
            :checkable="table.checkable"
            :mobile-cards="table.mobileCards"
            :paginated="table.paginated"
            :pagination-simple="table.paginationSimple"
            :per-page="table.perPage"
            :default-sort-direction="table.defaultSortDirection"
            :default-sort="table.defaultSort"

            :selected.sync="selected"
            :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"

            :loading="loading"
            :total="total"
            backend-sorting
            backend-pagination
            @page-change="onPageChange"
            @sort="onSort"
        >
            <template>
                <template>
                    <div v-for="col in tableColumns">
                      <o-table-column
                          :field="col.field"
                          :label="col.field === 'actions' ? '' : col.label"
                          :key="col.field"
                          :sortable="col.sortable"
                          #default="{ row }"
                      >
                        <template v-if="col.field === 'actor_id'">
                          <router-link v-if="itemReferenceName(row, 'actor')" :to="{ name: 'users.show', params: { slug: row.actor_id } }">
                            {{ itemReferenceName(row, 'actor') }}
                          </router-link>
                          <span v-else>Not Specified</span>
                        </template>
                        <span v-if="col.field === 'action'">{{ row.action }}</span>
                        <span v-if="col.field === 'meta'">{{ row.meta }}</span>
                        <router-link v-if="col.field === 'reference_id'" :to="itemReferenceLink(row)">
                          {{ $filters.valueOrDefault(itemReferenceName(row), 'Not Specified') }}
                        </router-link>
                        <span v-if="col.field === 'reference_type'">{{ $filters.ucfirst(row.reference_type) }}</span>
                        <span v-if="col.field === 'created_at'">{{ $filters.date(row.created_at) }}</span>
                      </o-table-column>
                    </div>
                </template>
            </template>

          <template #empty>
            <div class="has-text-centered">
              This table is empty!
            </div>
          </template>
        </o-table>

        <div>Total: <strong>{{ total }}</strong></div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Table from './../../mixins/Table'

    export default {
        mixins: [Table],

        data() {
            return {
                tableName: 'changelogs-index',
                selectedActivityType: null,
                filters: {
                    user_id: null,
                    reference_type: null
                },
                referenceTypes: [
                    {"id": 'proposal', "name": "Proposal"},
                    {"id": 'project', "name": "Project"},
                ]
            }
        },

        computed: {
            ...mapGetters({
                itemReferenceName: 'itemReferenceName',
                itemsByIds: 'activitiesByIds',
            }),

            ...mapGetters(['itemReferenceName', 'itemReferenceLink', 'userNameById'])
        },

        mounted() {
            this.fetchPaginatedData()
        },

        methods: {
            ...mapActions({
                fetchData: 'fetchActivities',
                removeItem: 'removeActivity',
            })
        }
    }
</script>
